// Libraries
import { action, observable } from "mobx";

// Core
import { ModelBase } from "Core/Models/ModelBase";
import { ColourSelection, SortDirection } from "Custom/Models";
import * as utils from "Custom/Utils";

export class DelcoteGSModel extends ModelBase<DelcoteGSModel, DelcoteGSModelDTO> {
    constructor() {
        super();
    }

    // #region Model Properties

    @observable
    // eslint-disable-next-line prettier/prettier
    public basecoatColourSelection: any = null;

    @observable
    public colours = observable<any>([]);

    @observable
    public boltsPerJoint: number = 0;

    @observable
    public girth: number = 0;

    @observable
    public gutterJoints: number = 0;

    @observable
    public gutterLengthMeterage: number = 0;

    @observable
    public topcoatColourSelection: any = null;

    // #region Model Properties

    @action
    public fromProductDataDto(colours: any[]): void {
        if (colours.length >= 2) {
            this.colours.replace([]);

            let local: ColourSelection[] = [];
            let specialColours: ColourSelection[] = [];
            for (const colour of colours) {
                if (colour.variantId === -1) {
                    specialColours.push({
                        title: colour.variantName,
                        value: colour.variantId,
                        group: "Special colours",
                    });
                } else {
                    local.push({
                        title: colour.variantName,
                        value: colour.variantId,
                        group: "Colours",
                    });
                }
            }

            this.colours.replace(utils.sortBy(local, "title", SortDirection.Asc));
            this.colours.push(...utils.sortBy(specialColours, "title", SortDirection.Asc));
            this.basecoatColourSelection = this.colours[1];
            this.topcoatColourSelection = this.colours[0];
        }
    }

    @action
    public fromDto(model: DelcoteGSModelDTO): void {
        throw new Error("Method not implemented.");
    }

    public toDto(): DelcoteGSModelDTO {
        return {
            basecoatColourId: this.basecoatColourSelection.value,
            basecoatColourName: this.basecoatColourSelection.title,
            boltsPerJoint: this.boltsPerJoint,
            girth: this.girth,
            gutterJoints: this.gutterJoints,
            gutterLengthMeterage: this.gutterLengthMeterage,
            topcoatColourId: this.topcoatColourSelection.value,
            topcoatColourName: this.topcoatColourSelection.title,
            version: 2,
        };
    }
}

export interface DelcoteGSModelDTO {
    basecoatColourId: number;
    basecoatColourName: string;
    boltsPerJoint: number;
    girth: number;
    gutterJoints: number;
    gutterLengthMeterage: number;
    topcoatColourId: number;
    topcoatColourName: string;
    version: number;
}
